import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";
import { ApiErrors } from "./ApiErrors";

export interface SaveCourseLanguageParams {
  id?: number;
  name: string;
  active: boolean;
}

export async function saveCourseLanguage(
  language: SaveCourseLanguageParams
): Promise<{ ok: boolean; message: string; errors?: string[]; data?: any }> {
  const localApi = await getLocalApi();

  const payload = {
    id: language.id ?? 0,
    name: language.name,
    isActive: !!language.active,
  };

  const result = await localApi.call(
    (apiConfig as any).course_languages_save,
    "POST",
    JSON.stringify(payload)
  );

  if (!result) {
    return {
      ok: false,
      message: "No response from API",
      data: null,
    };
  }

  const raw = await result.text();
  let data: any = null;
  try {
    data = raw ? JSON.parse(raw) : null;
  } catch {
  }

  const errors = ApiErrors.extractAllErrors(
    data,
    result,
    "Failed to save course language"
  );
  const message = result.ok
    ? (data?.message || "Saved")
    : ApiErrors.formatErrors(errors);

  return {
    ok: result.ok,
    message,
    errors: result.ok ? undefined : errors,
    data,
  };
}